import apiFetch from '../apiFetch'

export default function (token, processingAgencyOrganizedUnitConfigId, processAgencyCommunicationServiceId) {
  return apiFetch({ endPoint: `ProcessingAgencyOrganizedUnitConfigs/${processingAgencyOrganizedUnitConfigId}/${processAgencyCommunicationServiceId}`, method: 'DELETE', body: null, token: token })
}
